<template>
    <div class="annt-func-container">
        <div class="annt-func-item">
            <annt-accounting-entity-selector></annt-accounting-entity-selector>
        </div>
        <div class="annt-func-item">
            <annt-switch-owner></annt-switch-owner>
        </div>
        <div class="annt-func-item">
            <annt-doc-center></annt-doc-center>
        </div>
        <div class="annt-func-item">
            <annt-privacy></annt-privacy>
        </div>
        <div class="annt-func-item">
            <annt-file-list></annt-file-list>
        </div>
        <div class="annt-func-item">
            <annt-user :targetRoute="'/mod/ntp/user-center'"></annt-user>
        </div>
    </div>
</template>

<script>
import AnntDocCenter from '@/components/core/docCenter/DocCenter.vue';
import AnntPrivacy from '@/components/core/privacyPolicy/PrivacyPolicy.vue';
import AnntFileList from '@/views/components/fileList/FileList.vue';
import AnntUser from '@/views/user/User.vue';
import AnntSwitchOwner from '@/views/user/SwitchOwner.vue';
import AnntAccountingEntitySelector from '@/views/user/AccountingEntitySelector.vue';
export default {
    setup() {
    },
    components: {
        AnntDocCenter,
        AnntPrivacy,
        AnntFileList,
        AnntUser,
        AnntSwitchOwner,
        AnntAccountingEntitySelector
    }
};
</script>

<style lang="less">
.annt-func-container {
    display: flex;
    .el-button--text {
        color: #333;
        &:hover {
            color: #409eff;
            i {
                color: #409eff;
            }
        }
    }
    .annt-func-item {
        flex: 1;
        margin-left: 12px;
    }
}
</style>
